import greenLogo from '@assets/images/green-logo-no-text.png';
import styles from './styles.module.css';

type NoResultsProps = {
  headerTxt: string;
  contentTxt: string;
  actionButtons?: React.ReactNode;
  testId?: string;
};

export const NoResults: React.FC<NoResultsProps> = ({
  headerTxt,
  contentTxt,
  actionButtons,
  testId,
}) => {
  const getTestId = (suffix: string, fallback: string) => {
    if (testId) {
      return `${testId}-${suffix}`;
    }

    return fallback;
  };

  return (
    <div className={styles.wrapper} data-testid={getTestId('root', 'no-results')}>
      <img className={styles.logo} src={greenLogo} alt="Clevr360 logo" />
      <p className={styles.headerTxt} data-testid={getTestId('header', 'headerTxt')}>
        {headerTxt}
      </p>
      <p className={styles.contentTxt} data-testid={getTestId('content', 'contentTxt')}>
        {contentTxt}
      </p>
      {actionButtons && actionButtons}
    </div>
  );
};
